import { redirectToUrl } from "~/utils/url/urlUtils";

export function sendShaftResetConfigurator(productCode: string): void {
  redirectToUrl(`/shaft/${productCode}/shaftConfiguratorPage/reset`);
}
